import { MessageType, } from '@i18nspect/types';
import throttle from 'lodash.throttle';
import { addMessageListener } from './utils';
var isInit = false;
var callbackQueue = [];
var removeListener = addMessageListener({
    type: MessageType.Language_Init,
    callback: function () {
        if (isInit)
            return;
        isInit = true;
        callbackQueue.forEach(function (cb) { return cb(); });
        callbackQueue.length = 0;
        removeListener();
    },
});
// In case that the language toolbar is already init before the interceptor sets the listener
window.postMessage({
    type: MessageType.Language_CheckInit,
});
var hover = function (payload) {
    window.postMessage({
        type: MessageType.Language_Hover,
        payload: payload,
    });
};
var collectedKeyBuffer = [];
var throttledPostMessage = throttle(function () {
    window.postMessage({
        type: MessageType.Language_CollectKey,
        payload: collectedKeyBuffer,
    });
    collectedKeyBuffer = [];
}, 500);
var isCallbackPushed = false;
var collectKey = function (payload) {
    collectedKeyBuffer.push(payload);
    if (isInit) {
        throttledPostMessage();
    }
    else {
        if (!isCallbackPushed) {
            isCallbackPushed = true;
            callbackQueue.push(function () {
                throttledPostMessage();
            });
        }
    }
};
var onSwitchDisplay = function (cb) {
    return addMessageListener({
        type: MessageType.Language_SwitchDisplay,
        callback: cb,
    });
};
var onSetTranslations = function (cb) {
    return addMessageListener({
        type: MessageType.Language_SetTranslations,
        callback: cb,
    });
};
var initInterceptor = function (payload) {
    var action = function () {
        window.postMessage({
            type: MessageType.Language_InitInterceptor,
            payload: payload,
        });
    };
    if (isInit) {
        action();
    }
    else {
        callbackQueue.push(action);
    }
};
export default {
    hover: hover,
    collectKey: collectKey,
    onSwitchDisplay: onSwitchDisplay,
    onSetTranslations: onSetTranslations,
    initInterceptor: initInterceptor,
};
